import HACKTOBERFEST_2024 from "../../images/events/Hacktoberfest/hacktoberfest-2024.png";
import HACKTOBERFEST_2023 from "../../images/events/Hacktoberfest/hacktoberfest-2023.png";
import HACKTOBERFEST_2022 from "../../images/events/Hacktoberfest/hacktoberfest-2022.png";
import HACKTOBERFEST_2021 from "../../images/events/Hacktoberfest/hacktoberfest-2021.png";

export const HACKTOBERFEST = [
    {
      image: HACKTOBERFEST_2024,
      title: "Hacktoberfest 2024",
      description: "Hacktoberfest with MSTC lets tech enthusiasts contribute to open-source projects, win prizes, and explore new technologies while fostering collaboration and learning.",
      projects: [
        { name: "Routinr-Flutter", link: "https://github.com/MSTC-DA-IICT/Hacktoberfest24-Routinr-Flutter" },
        { name: "Quotes-App-Android", link: "https://github.com/MSTC-DA-IICT/Hacktoberfest24-Quotes-App-Android" },
        { name: "Wordle-Game-Nodejs", link: "https://github.com/MSTC-DA-IICT/Hacktoberfest24-Wordle-Game-Nodejs" },
        { name: "Drawing-Canvas-React", link: "https://github.com/MSTC-DA-IICT/Hacktoberfest24-Drawing-Canvas-React" },
        { name: "Quiz-App-React-Native", link: "https://github.com/MSTC-DA-IICT/Hacktoberfest24-Quiz-App-React-Native" },
        { name: "TicTacToe-GUI-Python-Basics", link: "https://github.com/MSTC-DA-IICT/Hacktoberfest24-TicTacToe-GUI-Python-Basics" },
        { name: "Candy-crush_HTML_CSS_JS", link: "https://github.com/MSTC-DA-IICT/Hacktoberfest24-candy-crush_HTML_CSS_JS" },
        { name: "Chess-Game-Python-Advanced", link: "https://github.com/MSTC-DA-IICT/Hacktoberfest24-Chess-Game-Python-Advanced" },
        { name: "Mushroom-Edibility-Prediction-ML", link: "https://github.com/MSTC-DA-IICT/Hacktoberfest24-Mushroom-Edibility-Prediction-ML" },
        { name: "Library-Management-System-Django", link: "https://github.com/MSTC-DA-IICT/Hacktoberfest24-Library-Management-System-Django" },
      ],
    },
    {
      image: HACKTOBERFEST_2023,
      title: "Hacktoberfest 2023",
      description: "Hacktoberfest with MSTC lets tech enthusiasts contribute to open-source projects, win prizes, and explore new technologies while fostering collaboration and learning.",
      projects: [
        { name: "ReACTivate", link: "https://github.com/MSTC-DA-IICT/Hacktoberfest23-ReACTivate" },
        { name: "SudoDroids", link: "https://github.com/MSTC-DA-IICT/Hacktoberfest2023-SudoDroids" },
        { name: "Delve into ML", link: "https://github.com/MSTC-DA-IICT/Hacktoberfest23-Delve-into-ML" },
        { name: "Python StarterKit", link: "https://github.com/MSTC-DA-IICT/Hacktoberfest23-Python-StarterKit" },
        { name: "The Interface Conundrum", link: "https://github.com/MSTC-DA-IICT/Hacktoberfest23-The-Interface-Conundrum" },
        { name: "PythonCraft: AdvanceEdition", link: "https://github.com/MSTC-DA-IICT/Hacktoberfest23-PythonCraft-AdvanceEdition" },
        { name: "Develop-Chess: HTML-CSS-JS", link: "https://github.com/MSTC-DA-IICT/Hacktoberfest23-Develop-Chess" },
        { name: "Expense Tracker App - Flutter", link: "https://github.com/MSTC-DA-IICT/Hacktoberfest23-Expense-Tracker-app-Flutter" },
        { name: "Sport Chat Web Application - Django", link: "https://github.com/MSTC-DA-IICT/HacktoberFest23-Django-SportChat-WebApp" },
        { name: "Real Time Chat Application - Node JS", link: "https://github.com/MSTC-DA-IICT/Hacktoberfest23-Real-time-Chat-app-Nodejs" },
      ]      
    },
    {
      image: HACKTOBERFEST_2022,
      title: "Hacktoberfest 2022",
      description: "Hacktoberfest with MSTC lets tech enthusiasts contribute to open-source projects, win prizes, and explore new technologies while fostering collaboration and learning.", 
      projects: [
          { name: "Blog-App", link: "https://github.com/MSTC-DA-IICT/Hacktoberfest22-Blog-App" },
          { name: "Fun-with-JS", link: "https://github.com/MSTC-DA-IICT/Hacktoberfest22-Fun-with-JS" },
          { name: "R-for-React", link: "https://github.com/MSTC-DA-IICT/Hacktoberfest22-R-for-React" },
          { name: "Mess-with-ML", link: "https://github.com/MSTC-DA-IICT/HacktoberFest22-Mess-with-ML" },
          { name: "Dare-2-Design", link: "https://github.com/MSTC-DA-IICT/Hacktoberfest22-dare-2-design" },
          { name: "Awesome-Android", link: "https://github.com/MSTC-DA-IICT/Hacktoberfest22-Awesome-Android" },
          { name: "Play-with-Python", link: "https://github.com/MSTC-DA-IICT/HacktoberFest22-Play-with-Python" },
          { name: "E-Learn-App-Django", link: "https://github.com/MSTC-DA-IICT/Hacktoberfest22-E-Learn-App-Django" }
      ]      
    },
    {
      image: HACKTOBERFEST_2021,
      title: "Hacktoberfest 2021",
      description: "Hacktoberfest with MSTC lets tech enthusiasts contribute to open-source projects, win prizes, and explore new technologies while fostering collaboration and learning.",
      projects: [
        { name: "We-demy", link: "https://github.com/MSTC-DA-IICT/We-demy" },
        { name: "B-for-Blog", link: "https://github.com/MSTC-DA-IICT/B-for-Blog" },
        { name: "Sun-Chokdi", link: "https://github.com/MSTC-DA-IICT/Sun-Chokdi" },
        { name: "OpenScripts", link: "https://github.com/MSTC-DA-IICT/OpenScripts" },
        { name: "REST-API-Node", link: "https://github.com/MSTC-DA-IICT/REST-API-Node" },
        { name: "React Portfolio", link: "https://github.com/MSTC-DA-IICT/react-portfolio" },
        { name: "Movie-WatchList", link: "https://github.com/MSTC-DA-IICT/Movie-WatchList" },
        { name: "Data-Science-Machine-Learning", link: "https://github.com/MSTC-DA-IICT/Data-Science-Machine-Learning" },
      ]      
    },
];